import React, { useEffect } from 'react'
import { Button, Card, Form, Input } from 'antd'
import {
  $group,
  $isSuccessCreate,
  closeModal,
  groupMounted,
  submitEditGroup,
} from './model'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'
import { path } from '../../../../libs'

interface FormData {
  name: string
}

export const EditGroup = () => {
  const navigate = useNavigate()
  const group = useUnit($group)
  const [form] = Form.useForm<FormData>()

  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  useEffect(() => {
    groupMounted()
  }, [])

  useEffect(() => {
    form.setFieldsValue({ name: group.name })
  }, [group, form])

  useEffect(() => {
    if (isSuccessCreate) {
      navigate(path.groups.entry())
      modalCloseFn()
    }
  }, [isSuccessCreate])

  const onFinish = (values: FormData) => {
    submitEditGroup({ ...values, role: group.role.id })
  }

  return (
    <Card title={<strong>Edit group</strong>}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 520 }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Имя обязательно' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
